var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:['product-sticky-header', { 'product-sticky-header--show' : _vm.show }]},[_c('div',{staticClass:"container container--main"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }